import { createContext, useEffect, useState } from "react";
import "./App.css";
import "animate.css/animate.min.css";
import Home from "./components/Home/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import Users from "./components/Dashboard/DashboardSubComponent/Users/Users";
import Cart from "./components/Header/Cart/Cart";

export const tokenContext = createContext();

function App() {
  return (
    <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <PrivateRoute exact path="/dashboard">
          <Dashboard />
          </PrivateRoute>
          <PrivateRoute path="/dashboard/:routeName">
            <Dashboard />
          </PrivateRoute>
          <PrivateRoute path="/cart">
            <Cart />
          </PrivateRoute>
        </Switch>
    </BrowserRouter>
  );
}

export default App;
